export const PRODUCT_DETAILS_DRAWER_TAB_PARAM_KEY = 'productDetailsDrawerTab'
export const PRODUCTS_EDIT_DRAWER_TAB_PARAM_KEY = 'productsEditDrawerTab'
export const DOMICILE_CLASS_DRAWER_TAB_PARAM_KEY = 'domicileClassDrawerTab'
export const SALES_RULES_TAB_PARAM_KEY = 'salesRulesDrawerTab'
